import { ChallengeResponse } from './ChallengeResponse';
import { removeFromArray } from '@standardnotes/utils';
/**
 * A challenge operation stores user-submitted values and callbacks.
 * When its values are updated, it will trigger the associated callbacks (valid/invalid/complete)
 */
export class ChallengeOperation {
    constructor(challenge, onValidValue, onInvalidValue, onNonvalidatedSubmit, onComplete, onCancel) {
        this.challenge = challenge;
        this.onValidValue = onValidValue;
        this.onInvalidValue = onInvalidValue;
        this.onNonvalidatedSubmit = onNonvalidatedSubmit;
        this.onComplete = onComplete;
        this.onCancel = onCancel;
        this.nonvalidatedValues = [];
        this.validValues = [];
        this.invalidValues = [];
        this.artifacts = {};
    }
    deinit() {
        ;
        this.challenge = undefined;
        this.onValidValue = undefined;
        this.onInvalidValue = undefined;
        this.onNonvalidatedSubmit = undefined;
        this.onComplete = undefined;
        this.onCancel = undefined;
        this.nonvalidatedValues = undefined;
        this.validValues = undefined;
        this.invalidValues = undefined;
        this.artifacts = undefined;
    }
    /**
     * Mark this challenge as complete, triggering the resolve function,
     * as well as notifying the client
     */
    complete(response) {
        var _a;
        if (!response) {
            response = new ChallengeResponse(this.challenge, this.validValues, this.artifacts);
        }
        (_a = this.onComplete) === null || _a === void 0 ? void 0 : _a.call(this, response);
    }
    nonvalidatedSubmit() {
        var _a;
        const response = new ChallengeResponse(this.challenge, this.nonvalidatedValues.slice(), this.artifacts);
        (_a = this.onNonvalidatedSubmit) === null || _a === void 0 ? void 0 : _a.call(this, response);
        /** Reset values */
        this.nonvalidatedValues = [];
    }
    cancel() {
        var _a;
        (_a = this.onCancel) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    /**
     * @returns Returns true if the challenge has received all valid responses
     */
    isFinished() {
        return this.validValues.length === this.challenge.prompts.length;
    }
    nonvalidatedPrompts() {
        return this.challenge.prompts.filter((p) => !p.validates);
    }
    addNonvalidatedValue(value) {
        const valuesArray = this.nonvalidatedValues;
        const matching = valuesArray.find((v) => v.prompt.id === value.prompt.id);
        if (matching) {
            removeFromArray(valuesArray, matching);
        }
        valuesArray.push(value);
        if (this.nonvalidatedValues.length === this.nonvalidatedPrompts().length) {
            this.nonvalidatedSubmit();
        }
    }
    /**
     * Sets the values validation status, as well as handles subsequent actions,
     * such as completing the operation if all valid values are supplied, as well as
     * notifying the client of this new value's validation status.
     */
    setValueStatus(value, valid, artifacts) {
        var _a, _b;
        const valuesArray = valid ? this.validValues : this.invalidValues;
        const matching = valuesArray.find((v) => v.prompt.validation === value.prompt.validation);
        if (matching) {
            removeFromArray(valuesArray, matching);
        }
        valuesArray.push(value);
        Object.assign(this.artifacts, artifacts);
        if (this.isFinished()) {
            this.complete();
        }
        else {
            if (valid) {
                (_a = this.onValidValue) === null || _a === void 0 ? void 0 : _a.call(this, value);
            }
            else {
                (_b = this.onInvalidValue) === null || _b === void 0 ? void 0 : _b.call(this, value);
            }
        }
    }
}
